<div class="terms-wrapper">
  <div class="container position-relative">
    <a (click)="goBack()" style="cursor: pointer;">
      <img src="assets/images/arrow_left_alt.svg" class="arrow" />
    </a>
    <h1 class="page-title ms-5">Refund & Cancellation Policy</h1>
  </div>
  <p class="body-text">
    BeExpert follows a transparent refund and cancellation process. All
    refunds are processed through Razorpay.
  </p>

  <div class="body-text">
    <h2 class="section-title">1. Refunds</h2>
    <span
      >Refunds are processed directly via Razorpay. Refund timelines vary
      depending on:</span
    >
    <ul>
      <li>Payment method used</li>
      <li>Bank processing time</li>
    </ul>

    <p class="body-text">
      <strong>Expected timeline: 5–7 working days</strong>
    </p>

    <p>
      For Razorpay-specific refund rules:
      <a href="https://razorpay.com/support" target="_blank" class="email-value"
        >Razorpay Support - Refunds</a
      >
    </p>
  </div>

  <div class="body-text">
    <h2 class="section-title">2. User Cancellations</h2>
    <ul>
     <li>Users may cancel a session up to 12 hours before the scheduled start time.</li>
     <li>If a cancellation is made within 12 hours of the session start time, no refund will be initiated.</li>
     <li>Eligible refunds will be processed automatically via Razorpay.</li>
    </ul>
  </div>

  <div class="body-text">
    <h2 class="section-title">3. No-Show Policy</h2>
    <span>If the user does not attend the session : </span>
    <li>No refund will be provided.</li>
  </div>

  <div class="body-text">
    <h2 class="section-title">4. Mentor/Platform Cancellation</h2>
    <span>If BeExpert cancels a session : </span>
    <li>A full refund is initiated automatically via Razorpay.</li>
  </div>

  <div class="body-text">
    <h2 class="section-title">5. Duplicate/Incorrect Payments</h2>
    <span>If a duplicate payment is made: : </span>
    <li>Refund will be initiated via Razorpay after verification.</li>
  </div>

   <h2 class="section-title">Contact Information</h2>
  <p>
    If you have any questions about service delivery, please contact us at
    <span class="email-value">{{ email }}</span>
  </p>
</div>